"use client";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { Col, Form, Row, Select, Tooltip } from "antd";

const InterestSettings = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    interestCalculationBasisOptions,
    interestStartDateOptions,
    firstCouponDate,
    interestPaymentModeOptions,
  } = props;

  return (
    <div>
      <h1
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          margin: 0,
          marginBottom: "24px",
        }}
      >
        Interest Settings
      </h1>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Interest Calculation Basis
                  <Tooltip title="Select interest calculation basis">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="interestCalculationBasis"
              rules={[
                {
                  required: true,
                  message: "Please select interest calculation basis",
                },
              ]}
            >
              <Select
                placeholder="Select interest calculation basis"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={interestCalculationBasisOptions}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Interest Start Date
                  <Tooltip title="Select the interest start date">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="interestStartDate"
              rules={[
                {
                  required: true,
                  message: "Please select interest start date",
                },
              ]}
            >
              <Select
                placeholder="Select interest start date"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={interestStartDateOptions}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  First Coupon Date
                  <Tooltip title="Select the first coupon date">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="firstCouponDate"
              rules={[
                {
                  required: true,
                  message: "Please select first coupon date",
                },
              ]}
            >
              <Select
                placeholder="Select first coupon date"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={firstCouponDate}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Interest Payment Mode
                  <Tooltip title="Select interest payment mode">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="interestPaymentMode"
              rules={[
                {
                  required: true,
                  message: "Please select interest payment mode",
                },
              ]}
            >
              <Select
                placeholder="Select payment mode"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={interestPaymentModeOptions}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default InterestSettings;
